import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaSearch } from "react-icons/fa";

const API_URL = `https://rickandmortyapi.com/api/character`

function HomePage() {

    const [characters, setCharacters] = useState([]);
    const [searchName, setSearchName] = useState(sessionStorage.getItem('searchName') ?? '');

    useEffect(() => {
        fetch(API_URL)
            .then(response => response.json())
            .then(data => setCharacters(data.results.sort((a, b) => a.name.localeCompare(b.name))))
            .catch(error => console.log(error));
    }, []);

    const handleSearchChange = event => {
        const value = event.target.value;
        setSearchName(value);
        sessionStorage.setItem('searchName', value);
    };

    const filteredCharacters = characters.filter(character =>
        character.name?.toLowerCase().includes(searchName.toLowerCase())
    );

    const handleInputFocus = () => {
        document.querySelector('.search-icon').style.opacity = 0;
    };

    const handleInputBlur = () => {
        const icon = document.querySelector('.search-icon');
        if (searchName.length === 0) {
            icon.style.opacity = 1;
        } else {
            icon.style.display = 'none';
        }
    };

    return (
        <div className='container'>

            <div className="bg-img"></div>

            <div className='search-wrap'>
                <FaSearch className="search-icon" />
                <input
                    type="text"
                    id="search-input"
                    className='search-input'
                    value={searchName}
                    placeholder="Filter by name..."
                    onChange={handleSearchChange}
                    onFocus={handleInputFocus}
                    onBlur={handleInputBlur}
                />
            </div>

            <ul className="character-grid">
                {filteredCharacters.map(({ id, image, name, species }) => (
                    <li className='character-item' key={id}>
                        <Link key={id} to={`/characters/${id}`}>
                            <img className='character-img' src={image} alt={name} />
                            <h3 className='character-name'>{name}</h3>
                        </Link>
                        <p className='character-specie'>{species}</p>
                    </li>
                ))}
            </ul>

        </div>
    );
}

export default HomePage;

